module.exports = __webpack_public_path__ + "img/20191116150045399.ed6efc25.jpg";